import { useContext, useEffect } from "react";
import { AppContext } from "../../Contexts/AppContext";
import ConnectivityReportTable from "./components/ConnectivityReportTable";
import DevicesScreen from "../DevicesScreen/DevicesScreen";
import DevicesSelector from "../../common/components/DevicesSelector/DevicesSelector";

export default function ConnectivityReportScreen() {
	//Get id from the URL
	const { setTitle } = useContext(AppContext);

	useEffect(() => {
		setTitle("Reporte de Conectividad");
	}, []);
	return (
		<div>
			<ConnectivityReportTable />
		</div>
	);
}
